<template>
  <div class="fullscreenmainStyle" :style="{ height: height + 'px' }">
    <ul>
      <li class="mainIcon" />
      <li class="mianDetail">
        <span v-if="linkIt==='2'">暂无资源，赶紧去分享吧~</span>
        <span v-if="linkIt==='1'">您还没有{{ label }},赶紧去添加吧~</span>
        <span v-if="linkIt==='3'">{{ label }}</span>
        <span v-if="linkIt==='0'" @click="addEvent">添加{{ label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'GlobalEmpty',
  props: {
    label: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: '600'
    },
    linkIt: {
      type: String,
      required: true
    }
  },
  methods: {
    addEvent() {
      this.$emit('addGlobalEmpty');
    }
  }
};
</script>

<style lang="scss">
.fullscreenmainStyle {
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .blue {
      color: #007AFC !important;
    }
    .mainIcon {
      width: 120px;
      height: 120px;
      background: url("../assets/img/allSprites.png") -210px -10px;
    }
    .mianDetail {
      cursor: pointer;
      span:nth-of-type(1) {
        font-size: 16px;
        color: rgba(153, 153, 153, 1);
      }
      span:nth-of-type(2) {
        color: #007AFC;
        font-size: 16px;
        margin-left: 30px;
      }
    }
  }
  span:nth-of-type(2) {
    color: #007AFC;
    font-size: 16px;
    margin-left: 30px;
  }
}
</style>
